<template>
    <div>
        <TableActionHeader 
            ref="th" 
            @filterChange="onFilterChange"
            :selectOptions="stateOptions"
            :selected="stateFilter"
            @filterSelect="onFilterSelect"
            @newItem="onNewItem" 
            :newButton="$UIPrivilegeC('content/timetables')">>
        </TableActionHeader> 
        <b-table id="timetableviews" ref="tbl" striped hover selectable sticky-header="calc(100vh - 350px)"
            select-mode="single" 
            @row-selected="onRowSelected" 
            :items="items" 
            :fields="fields" 
            :filter="filter"
            @filtered="onFiltered"
            :filter-function="filterFunction"
            :per-page="perPage"
            :current-page="currentPage"
            primary-key="id"
            :busy="loading">
            <template v-slot:cell(mode)="data">
                <b-icon v-if="data.value=='1'" icon="filter-square" scale='1.5' variant="success"></b-icon>
                <b-icon v-if="data.value=='2'" icon="info-square" scale='1.5' variant="info"></b-icon>
                <b-icon v-if="data.value=='0'" icon="square-fill" scale='1.5' variant="dark"></b-icon>
            </template> 
        
            <template v-slot:cell(stops)="data">
                <div v-for="(stop, idx) in getTimetableViewStops(data.item)" :key="idx" >
                    <div v-b-tooltip.left :title='stop.nimi' v-if="stop.type == 'stop'"><b-icon icon="geo-alt-fill" scale='1' variant='danger'/>&nbsp;<router-link :to="{ path: '/timetables/stops', query: { id:  stop.name.split(' ')[0]  }}">{{ stop.name }} </router-link></div>
                    <div v-if="stop.type == 'externalDs'"><b-icon icon="link45deg" scale='1.5' variant='dark'/>&nbsp; {{ stop.name }} </div>
                </div>
            </template>
            <template v-slot:cell(devices)="data">
                <div  v-b-tooltip.left :title='device.name' v-for="(device, idx) in getTimetableViewDevices(data.item)" :key="idx">
                    <b-icon icon="view-list" scale='1' variant='success'/>&nbsp;<router-link :to="{ path: '/devices/infopoints', query: { id:  device.uniqueId }}">{{ device.uniqueId}}</router-link>
                </div>
              
            </template>
            <template #table-busy>
                <Loading />
            </template>
        </b-table>
    
        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
    </template>
    
<script>
    import timetableview from '@/store/content/timetableview.js'
    import stop from '@/store/timetable/stop'
    
    export default {
        data() {
            return {
                perPage: 15,
                currentPage: 1,
                stateFilter: "ALL",
                stateOptions: [
                    { id: 'ALL', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("timetables.mode") },
                    { id: '1', label: this.$t('timetables.modes.NORMAL'), icon: 'filter-square', variant: 'success' },
                    { id: '2', label: this.$t('timetables.modes.ONLY_INFO'), icon: 'info-square', variant: 'info' },
                    { id: '0', label: this.$t('timetables.modes.BLANK'), icon: 'square-fill', variant: 'dark' }
                ] ,
                fields: [
                    { key: "mode", label: this.$t('timetables.mode'), tdClass: 'status'},
                    { key: "id", label: this.$t('timetables.id') },
                    { key: "name", label: this.$t('timetables.name') },
                    { key: "stops", label: this.$t('timetables.stops'), tdClass: 'stops' },
                    { key: "devices", label: this.$t('timetables.devices'), tdClass: 'stops' }
                ],
                filter: "",
                filteredRows: 0,
                loading: true,
                itemsUpdatedTime: 0,
                externalDataSources: [],
                timetableViewDevices: []
            }
        },
        computed: {
            items() {
                try {
                    var views = this.$store.state.timetableview.views;
                } catch (err) {
                    console.warn('Views not found')
                }
                if (this.stateFilter != 'ALL') {
                    var filtered = [];
                    const self = this;
                    views.forEach(function (view) {
                        if(self.stateFilter == view.mode)
                            filtered.push(view);
                    });
                    views =  filtered;
                }
                return views;
                //return this.$store.state.timetableview.views;
            },
            totalRows() {
                return this.filter ?  this.filteredRows : this.items.length;
            },
            timetableViewStops(){
                return this.$store.state.timetableview.stops;
            },
            stopList(){
                return this.$store.state.stop.stopList;
            },
            stopMap(){
                return this.$store.state.stop.stopMap;
            }
    
        },
        created: function() {
            if (!this.$store.state.timetableview ) this.$store.registerModule("timetableview" , timetableview )
            const p1 = this.$store.dispatch('timetableview/list')
            const p2 = this.$store.dispatch('timetableview/stops')
    
            if (!this.$store.state.stop) this.$store.registerModule("stop" , stop);
            const p3 = this.$store.dispatch('stop/getStopList');
    
            this.loading = true;
            Promise.all([p1, p2, p3]).finally(() => {
                this.loading = false; 
            });
           this.getExternalDataSources();
    
           this.getDevices();
        
        },
        watch: {
            '$store.state.timetableview.views': function(){
                this.itemsUpdatedTime = Date.now();
            },
        },
        mounted() {
            if(this.$route.query.id) {
                this.filter = this.$route.query.id;
                this.$refs.th.setFilterValue(this.filter);
            }
        },
        methods: {
            onFilterChange(filter) {
                this.filter = filter;
            },
            onFilterSelect(id){
                this.stateFilter = id;
            },
            onNewItem() {
                this.$emit('newItem');
            },
            onRowSelected(items) {
                //console.log("row selected:" + items);
            

                let now = Date.now();
               
                //if statement to prevent from unselecting after adding a new item.
                //When a new item is created (in TimetableViewForm.vue), table of items is reloaded and it calls onRowSelected with undefined,
                //what emits selectItem with undefined to Timetables.vue, and it closes TimetableViewForm.vue. We don't want it.
                //So that emit will be only called only if onRowSelected was not called by adding a new item
                if((now - this.itemsUpdatedTime > 100) && items[0] )
                    this.$emit('selectItem' , items[0] );
            },
            onFiltered(filteredItems) {
                this.filteredRows = filteredItems.length;
    
                if(filteredItems.length == 1){
                    setTimeout(() => {
                        let row = this.$refs.tbl.selectRow(0)
                        if(row) row.click();
                     }, 100);
                }
    
            },
            onPageChange(selectedPage) {
                this.currentPage = selectedPage;
            },
            getTimetableViewStops(view){
                let stopList = [];
                var viewStops = this.timetableViewStops[view.id];
                if(viewStops){
                    viewStops.forEach( vstop => {
                        let name = vstop;
                        let nimi = "";
                        let stop = this.stopMap.get(vstop);
                        if(stop){
                            if(stop.nimi) {
                                nimi = stop.nimi;
                            }
                            if(stop.sms)
                                name += " (" + stop.sms + ")"
    
                            if(stop.laituri && stop.laituri.trim().length > 0 && stop.laituri != "0")
                                name += " [" + stop.laituri + "]"
                       
                        }
        
                        stopList.push( { "name": name, "type": "stop", "nimi": nimi } );
                    });
                }
    
                let externalDataSource = this.externalDataSources.find(ds => ds.display == view.id);
                if(externalDataSource){
                    stopList.push({ "name": externalDataSource.source, "type": "externalDs" });
                }
               
                return stopList;
            },
            getTimetableViewDevices(view){
                return this.timetableViewDevices[view.id] ? this.timetableViewDevices[view.id] : [];
        },
    
            getExternalDataSources(){
                this.$traveller_http.get('/traveller/restui/content/timetableview/externalSourcesAll' )
                .then( response => {
                    this.externalDataSources = response.data;
                })
                .catch( () => {} ) 
                .finally( () => {} ); 
            },
            getDevices(){
                this.$traveller_http.get('/traveller/restui/content/timetableview/devices' )
                .then( response => {
                    this.timetableViewDevices = response.data;
                })
                .catch(() => { })
        },

        filterFunction(item, filter) {
            const searchWords = filter.toLowerCase().split(' ');
            const searchText = `${item.id} ${item.name}`.toLowerCase();

            return searchWords.every(word => searchText.includes(word));
        },

    }
}

    </script>
    
    
<style scoped lang="scss">


    #timetableviews td.stops {
         font-family: Verdana, Arial, Helvetica, sans-serif;
         font-size: 13px;
    }

    
</style>